// @core/api/endpoints/analytics/update_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DashboardResponse,
  UpdateDashboardRequest,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Update dashboard
 * Updates dashboard properties, layout, and widget placements.
 */
export async function UpdateDashboard(
  dashboard_id: string,
  data: UpdateDashboardRequest,
  options?: RequestOptions
): Promise<DashboardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.put<DashboardResponse>(requestPath, data, requestOptions);
}
